/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../common";
import type {
  XyoWorldMinterVersion2,
  XyoWorldMinterVersion2Interface,
} from "../XyoWorldMinterVersion2";

const _abi = [
  {
    inputs: [
      {
        internalType: "contract IXyoWorldGeotokens",
        name: "geotokenssToSell",
        type: "address",
      },
      {
        internalType: "contract IBurnableErc20",
        name: "currencyToPay",
        type: "address",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "by",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "startingBid",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint32",
        name: "length",
        type: "uint32",
      },
    ],
    name: "AuctionStarted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "by",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "BidPlaced",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "by",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "GeotokenMinted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "by",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "initialStartingBid",
        type: "uint256",
      },
    ],
    name: "MinterStarted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "MintingFeeSent",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "RefundedCurrentBid",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "from",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "TokensBurned",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "uint256",
        name: "to",
        type: "uint256",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "from",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "TokensFlowed",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "bidder",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "currentBid",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "endTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "expired",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getNow",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "hasBid",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "startTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "started",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "startingBid",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "randomSlotCount",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "slot",
        type: "uint256",
      },
    ],
    name: "randomSlotOdds",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "slot",
        type: "uint256",
      },
    ],
    name: "randomSlotWeight",
    outputs: [
      {
        internalType: "int16",
        name: "",
        type: "int16",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "currency",
    outputs: [
      {
        internalType: "contract IBurnableErc20",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "tokens",
    outputs: [
      {
        internalType: "contract IMintableErc721",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "geotokens",
    outputs: [
      {
        internalType: "contract IGeotokenErc721",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "hasMinted",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "canMintForReward",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "mintForReward",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "initialStartingBid",
        type: "uint256",
      },
      {
        internalType: "address",
        name: "geotokenZeroOwner",
        type: "address",
      },
    ],
    name: "start",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "bidAmount",
        type: "uint256",
      },
    ],
    name: "bid",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "bidFeePercent",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "bidAmount",
        type: "uint256",
      },
    ],
    name: "bidFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "minimumBidIncreasePercent",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "minimumBid",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "dutchAuctionActive",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "dutchAuctionPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "basePrice",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "age",
        type: "uint256",
      },
    ],
    name: "calcDutchAuctionPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "mintNowPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "mintNowFee",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

const _bytecode =
  "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";

type XyoWorldMinterVersion2ConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: XyoWorldMinterVersion2ConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class XyoWorldMinterVersion2__factory extends ContractFactory {
  constructor(...args: XyoWorldMinterVersion2ConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    geotokenssToSell: PromiseOrValue<string>,
    currencyToPay: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<XyoWorldMinterVersion2> {
    return super.deploy(
      geotokenssToSell,
      currencyToPay,
      overrides || {}
    ) as Promise<XyoWorldMinterVersion2>;
  }
  override getDeployTransaction(
    geotokenssToSell: PromiseOrValue<string>,
    currencyToPay: PromiseOrValue<string>,
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      geotokenssToSell,
      currencyToPay,
      overrides || {}
    );
  }
  override attach(address: string): XyoWorldMinterVersion2 {
    return super.attach(address) as XyoWorldMinterVersion2;
  }
  override connect(signer: Signer): XyoWorldMinterVersion2__factory {
    return super.connect(signer) as XyoWorldMinterVersion2__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): XyoWorldMinterVersion2Interface {
    return new utils.Interface(_abi) as XyoWorldMinterVersion2Interface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): XyoWorldMinterVersion2 {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as XyoWorldMinterVersion2;
  }
}
